import { d as s, _ as c } from "./_plugin-vue_export-helper-8568c831.mjs";
import { openBlock as o, createElementBlock as t, normalizeClass as r, normalizeStyle as n, createElementVNode as l } from "vue";
const a = s("order"), i = /* @__PURE__ */ l("path", {
  d: "M751.543 1024H268.8c-128 0-234.057-109.714-234.057-241.371V362.057c0-135.314 106.057-241.371 234.057-241.371V230.4c-69.486-3.657-124.343 58.514-124.343 131.657V782.63c0 73.142 54.857 131.657 124.343 131.657h486.4c65.829 0 124.343-58.515 124.343-131.657V362.057c0-73.143-54.857-131.657-124.343-131.657V120.686c128 0 234.057 109.714 234.057 241.371V782.63C985.6 914.286 883.2 1024 751.543 1024zM601.6 329.143H418.743c-91.429 0-164.572-73.143-164.572-164.572S327.314 0 418.743 0H601.6c91.429 0 164.571 73.143 164.571 164.571S693.03 329.143 601.6 329.143zM418.743 109.714c-29.257 0-54.857 25.6-54.857 54.857s25.6 54.858 54.857 54.858H601.6c29.257 0 54.857-25.6 54.857-54.858s-25.6-54.857-54.857-54.857H418.743zM601.6 768H418.743c-29.257 0-54.857-25.6-54.857-54.857s25.6-54.857 54.857-54.857H601.6c29.257 0 54.857 25.6 54.857 54.857S630.857 768 601.6 768zm0-182.857H418.743c-29.257 0-54.857-25.6-54.857-54.857s25.6-54.857 54.857-54.857H601.6c29.257 0 54.857 25.6 54.857 54.857s-25.6 54.857-54.857 54.857z",
  fill: "currentColor",
  "fill-opacity": "0.9"
}, null, -1), p = [
  i
];
function d(e, m, _, f, H, z) {
  return o(), t("svg", {
    class: r(e.classes),
    style: n(e.style),
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    role: "presentation"
  }, p, 6);
}
const u = /* @__PURE__ */ c(a, [["render", d]]);
export {
  u as default
};
